export const internalUrl = (todo) => {
  switch (todo.type) {
    case 'DRIVER_LICENSE':
    case 'REGISTRATION':
    case 'PROOF_OF_INSURANCE':
    case 'PROOF_OF_EMPLOYMENT':
    case 'CONTACT_LIENHOLDER':
    case 'UPDATE_LIENHOLDER':
    case 'LOSS_PAYEE':
    case 'VERIFY_FUNDS':
    case 'TITLE':
    case 'VERIFY_MILEAGE':
    case 'SIGN_LOAN_AGREEMENT':
    case 'CARFAX_FRAUD_REVIEW':
    case 'SUBMIT_PROOF_OF_INCOME':
    case 'HANDLE_INSUFFICIENT_FUNDS':
    case 'UPDATE_LIENHOLDER_INFO':
    case 'APP_FOR_TITLE':
    case 'RECEIVE_SPOA':
    case 'RECEIVE_LPOA':
    case 'SEND_SPOA_TO_SELLER':
    case 'SEND_BUYER_PACKET':
    case 'RECEIVE_APP_FOR_TITLE':
    case 'REVIEW_PLAID_DATA_MISMATCH':
    case 'REVIEW_USER_DATA_MISMATCH':
    case 'REVIEW_FOR_FRAUD':
    case 'HANDLE_TITLE':
    case 'SEND_FUNDS_TO_LIENHOLDER':
      return `/tasks/${todo.task.id}/edit`
    default:
      return null
  }
}

export const externalUrl = (todo, userId, vehicleId, offerId) => {
  switch (todo.type) {
    case 'REVIEW_OFAC':
    case 'FINAL_LOAN':
    case 'REVIEW_STATEMENT':
      return `${process.env.REACT_APP_ADMIN_WEB_URL}detail/${userId}?vehicle=${vehicleId}&offer=${offerId}`
    default:
      return null
  }
}

// Where an agent adds or fixes a customer's address. With no address on file the
// list page would only offer "Add an Address", so go straight to that form.
export const userAddressPath = (user: {
  id: string | number
  addresses?: unknown[]
}) =>
  user.addresses && user.addresses.length > 0
    ? `/users/${user.id}/address`
    : `/users/${user.id}/address/new`
